import React from 'react';
import { Lightbulb, BrainCircuit, Code, Users as UsersIcon, Shield, Heart } from 'lucide-react';
import { stemSkills, founders, mentors } from '../../data/mock';

const skillIcons = [Lightbulb, BrainCircuit, Code, UsersIcon, Shield, Heart];

const MissionSection = () => {
  const gaganGoyal = founders.find(f => f.name === "Gagan Goyal");

  return (
    <section data-testid="mission-section" className="relative py-20 md:py-32 bg-cream overflow-hidden">
      {/* Background Gradient */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-pragmatic/15 to-transparent" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block text-dwarfpony text-sm font-semibold tracking-wider uppercase mb-4">
            Our Mission
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-deepwalnut mb-6">
            Promoting STEM Education Through
            <span className="text-richolive"> Real-World Learning</span>
          </h2>
        </div>

        <div className="grid lg:grid-cols-3 gap-8">
          {/* Founder Card */}
          {gaganGoyal && (
            <div className="bg-gradient-to-br from-pragmatic/20 to-cream border border-dwarfpony/30 rounded-2xl p-6 hover:shadow-lg transition-all">
              <h3 className="text-dwarfpony text-sm font-semibold uppercase tracking-wider mb-4">Our Founder</h3>
              <div className="flex items-center gap-4 mb-4">
                <img
                  src={gaganGoyal.image}
                  alt={gaganGoyal.name}
                  className="w-16 h-16 rounded-xl object-cover"
                />
                <div>
                  <p className="text-deepwalnut font-bold">{gaganGoyal.name}</p>
                  <p className="text-heavyrain text-sm">{gaganGoyal.title}</p>
                </div>
              </div>
              <ul className="space-y-2 mt-4">
                {gaganGoyal.achievements.slice(0, 6).map((achievement, i) => (
                  <li key={i} className="flex items-start gap-2 text-heavyrain text-sm">
                    <span className="w-1.5 h-1.5 rounded-full bg-dwarfpony mt-2 flex-shrink-0" />
                    {achievement}
                  </li>
                ))}
              </ul>
            </div>
          )}

          {/* Mentors */}
          <div className="bg-gradient-to-br from-pragmatic/20 to-cream border border-dwarfpony/30 rounded-2xl p-6 hover:shadow-lg transition-all">
            <h3 className="text-dwarfpony text-sm font-semibold uppercase tracking-wider mb-4">Our Mentors</h3>
            <p className="text-heavyrain text-sm mb-4">100+ industry experts guiding students</p>
            <div className="grid grid-cols-3 gap-3">
              {mentors.slice(0, 6).map((mentor) => (
                <div key={mentor.id} className="text-center group">
                  <img
                    src={mentor.image}
                    alt={mentor.name}
                    className="w-12 h-12 rounded-full object-cover mx-auto border-2 border-transparent group-hover:border-dwarfpony transition-colors"
                  />
                  <p className="text-deepwalnut text-xs mt-2 font-medium truncate">{mentor.name.split(' ')[0]}</p>
                  <p className="text-heavyrain text-[10px] truncate">{mentor.role}</p>
                </div>
              ))}
            </div>
          </div>

          {/* STEM Skills */}
          <div className="bg-gradient-to-br from-pragmatic/20 to-cream border border-dwarfpony/30 rounded-2xl p-6 hover:shadow-lg transition-all">
            <h3 className="text-dwarfpony text-sm font-semibold uppercase tracking-wider mb-4">Skills for the Future</h3>
            <p className="text-heavyrain text-sm mb-6">STEM helps build essential skills that define tomorrow's leaders</p>
            <div className="grid grid-cols-2 gap-3">
              {stemSkills.map((skill, index) => {
                const Icon = skillIcons[index];
                return (
                  <div key={index} className="flex items-center gap-2 bg-cream rounded-lg p-3 border border-pragmatic/20">
                    <Icon size={16} className="text-dwarfpony flex-shrink-0" />
                    <span className="text-deepwalnut text-xs font-medium">{skill}</span>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MissionSection;
